const INITIAL_STATE = {
  words: [],
  text: "",
  isDefinitionVisible: false,
  definitionSelected: "",
  definition: "",
  definitionRequesting: false,
  wordSelected: "",
  requesting: false,
  sorted: "alphabetically",
  error: "",
};

const reducer = (state = INITIAL_STATE, action) => {
  return state;
};

export default reducer;
